import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import SearchBar from '../../../components/SearchBar';
import {OPERATOR, WhereConstraints} from '../../../graphql/common.datatypes';
import {SearchFilter} from './SearchFilter';
import Results from './Results';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import getDocuments from '../getDocuments.api';
import {checkIsAdmin} from '../../../utils/checkIsAdmin';
import {WcvDocument} from '../../../graphql/documents.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    }
}));

export interface FilterValues {
    name?: number
}

export const DocumentListContent = (props: { type?: number, type_id?: number, parentDocumentId?: number, isAdmin?: boolean, showViewAndVerify?: boolean, setSelectedDocument?: (document: WcvDocument) => void, }) => {
    const classes = useStyles();
    const { showViewAndVerify, setSelectedDocument } = props;
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [page, setPage] = useState(1);
    const initialFilters = {};

    const isAdmin = checkIsAdmin();

    const applyFilters = (newFilters: FilterValues) => {
        setFilters(newFilters);
        setWhere(getConstraintsFromFilters(newFilters));
    };

    const getConstraintsFromFilters = (newFilters: FilterValues) => {
        const whereConstraints: WhereConstraints = {
            AND: [],
        };

        if (props.type && props.type_id) {
            whereConstraints.AND!.push({column: 'type', operator: OPERATOR.EQ, value: props.type});
            whereConstraints.AND!.push({column: 'type_id', operator: OPERATOR.EQ, value: props.type_id});
        }

        if (props.parentDocumentId) {
            whereConstraints.AND!.push({
                column: 'parent_document_id',
                operator: OPERATOR.EQ,
                value: props.parentDocumentId
            });
        }

        return whereConstraints;
    };

    const [filters, setFilters] = useState(initialFilters);
    const [where, setWhere] = useState(getConstraintsFromFilters(initialFilters));
    const [orderBy] = useState([{column: 'created_at', order: 'DESC'}]);
    const documentsData = getDocuments(rowsPerPage, page, where, orderBy);

    return (
        <React.Fragment>
            {isAdmin && (
                <SearchBar filterContent={<SearchFilter filters={filters} initialFilters={initialFilters}
                                                        applyFilters={applyFilters}/>}/>
            )}
            <LoadingOverlay loading={documentsData.loading}>
                {documentsData.data && documentsData.data.documents && (
                    <Results
                        className={classes.results}
                        documents={documentsData.data.documents.data}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        paginatorInfo={documentsData.data.documents.paginatorInfo}
                        setPage={setPage}
                        setSelectedDocument={setSelectedDocument}
                        showViewAndVerify={showViewAndVerify}
                        isAdmin={isAdmin}
                    />
                )}
            </LoadingOverlay>
        </React.Fragment>
    );
};

const DocumentsList = () => {
    const classes = useStyles();
    const title = 'Documents';
    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="documents" title={title}/>
            <DocumentListContent/>
        </Page>
    );
};


export default DocumentsList;
